import { useQuery } from '@tanstack/react-query';

import { IAllUniversities } from '../models';
import { getUniversityByName } from '../queries';
import { universitiesConst } from '..';

export const useUniversityByName = (univerName?: string | string[]) => {
  const { data: university, ...args } = useQuery<IAllUniversities>({
    queryKey: [universitiesConst.queryKeys.UNIVERSITY_BY_NAME, univerName],
    queryFn: getUniversityByName(univerName),
    enabled: !!univerName
  });

  return { university, ...args };
};
